import { Users } from "lucide-react";

export default function UnitWidget({ item, handleSelect }: any) {
  return (
    <div
      key={item._id}
      className="flex-shrink-0 w-64 p-5 bg-blue-50 border border-blue-200 hover:bg-blue-100 rounded-lg transition duration-300 transform hover:-translate-y-0.5 cursor-pointer"
      onClick={() => {
        handleSelect(item);
      }}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-x-2">
          <Users className="w-8 h-8 text-blue-500" />
          <div className="flex flex-col">
            <div className="text-md font-semibold text-gray-900 truncate w-32">
              {item.businessUnit}
            </div>
            <div className="text-xs text-gray-500 mt-1">All Requests</div>
          </div>
        </div>
        <span className="text-3xl font-extrabold text-blue-600">
          {item.count}
        </span>
      </div>
    </div>
  );
}
